var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAskForModification(_vm.account, _vm.schoolList))?_c('BaseFlow',{attrs:{"icon":"fas fa-undo-alt","skip-confirm":true},on:{"click":_vm.sendMail}},[_vm._v(" Répondre à Coop Zone ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }